const EXPORT_MONTH_PATTERN = /^\d{4}-(0[1-9]|1[0-2])$/;

export function normalizeExportMonth(value) {
  if (typeof value !== "string") return null;

  const normalized = value
    .trim()
    .replace(/^["']+|["']+$/g, "");

  return EXPORT_MONTH_PATTERN.test(normalized) ? normalized : null;
}
